var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2064",
    "data-name": "Group 2064",
    transform: "translate(-1027 -1872)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_459",
    "data-name": "Ellipse 459",
    cx: 62,
    cy: 62,
    r: 62,
    transform: "translate(1027 1872)",
    fill: "#e5eff7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "people",
    transform: "translate(1045.5 1895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M50.565,86.662A38.147,38.147,0,1,1,43.407,11H43.7a2.129,2.129,0,0,1,2.125,2.13v.043A33.915,33.915,0,0,0,79.738,47.088a2.045,2.045,0,0,1,2.049,2.035v.021A38.015,38.015,0,0,1,71.2,75.517a.687.687,0,0,1-.353.2c-6.445,1.394-17.107,8.9-19.332,10.535a2.316,2.316,0,0,1-.952.415Z",
    transform: "translate(0 -9.288)",
    fill: "#a6a5c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M276.2,49.144h-38.15a2.288,2.288,0,0,1-2.288-2.288V13.288A2.282,2.282,0,0,1,238.037,11h.023A38.144,38.144,0,0,1,276.2,49.144Z",
    transform: "translate(-194.416 -9.287)",
    fill: "#dedeeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M41.265,240.838a2.379,2.379,0,0,1,2.379,2.379v38.126A38.144,38.144,0,0,1,5.5,243.2v-.024a2.349,2.349,0,0,1,2.355-2.337Z",
    transform: "translate(0 -203.342)",
    fill: "#c8d1e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M43.644,11V49.144H5.5A38.144,38.144,0,0,1,43.644,11Z",
    transform: "translate(0 -9.287)",
    fill: "#b8c3d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M294.5,184.526v-2.381a10.8,10.8,0,0,1,10.8-10.8h3.323a10.8,10.8,0,0,1,10.8,10.8v2.381Z",
    transform: "translate(-244.006 -144.669)",
    fill: "#207bbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M428.127,87.83v.9a2.248,2.248,0,0,1-4.5,0v-.9a2.248,2.248,0,0,1,4.5,0Z",
    transform: "translate(-353.032 -72.258)",
    fill: "#954d3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M318.586,20.383v3.6a9.9,9.9,0,0,1-6.819,9.406v2.4a3.073,3.073,0,0,1-6.147,0v-2.4a9.919,9.919,0,0,1-6.18-5.9,2.25,2.25,0,0,1-2.887-2.156v-.9a2.248,2.248,0,0,1,2.248-2.248v-1.8a9.892,9.892,0,1,1,19.785,0Z",
    transform: "translate(-245.739 -8.858)",
    fill: "#a95947"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M311.093,19.823a9.893,9.893,0,0,1,19.753,0,14.035,14.035,0,0,0-19.753,0Z",
    transform: "translate(-258.016 -8.858)",
    fill: "#67382a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M61.988,14.24A14.24,14.24,0,1,1,47.748,0a14.24,14.24,0,0,1,14.24,14.24Z",
    transform: "translate(-23.647)",
    fill: "#463b83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M69.86,182.776v2.283H44.94v-2.283a10.8,10.8,0,0,1,10.8-10.8h3.323A10.8,10.8,0,0,1,69.86,182.776Z",
    transform: "translate(-33.3 -145.202)",
    fill: "#ffe181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M178.568,88.44v.9a2.248,2.248,0,1,1-4.5,0v-.9a2.248,2.248,0,1,1,4.5,0Z",
    transform: "translate(-142.326 -72.773)",
    fill: "#d89c56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M69.026,20.992v3.6A9.9,9.9,0,0,1,62.207,34v2.4a3.073,3.073,0,1,1-6.147,0V34a9.919,9.919,0,0,1-6.18-5.9,2.25,2.25,0,0,1-2.887-2.156v-.9a2.248,2.248,0,0,1,2.248-2.248v-1.8a9.892,9.892,0,1,1,19.785,0Z",
    transform: "translate(-35.033 -9.372)",
    fill: "#e3ac6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M74.473,13.817l-.438,2.923a.514.514,0,0,1-.508.437H62.906A9.739,9.739,0,0,1,72.569,9.1c4.733,0,9.663,3.669,9.663,8.077H77.514a.514.514,0,0,1-.459-.284l-1.615-3.23a.513.513,0,0,0-.967.154Z",
    transform: "translate(-48.469 -7.683)",
    fill: "#463b83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M77.209,250.8v16.384a1.557,1.557,0,0,1-1.557,1.557H57.168a1.557,1.557,0,0,1-1.557-1.557V250.8a10.8,10.8,0,0,1,21.6,0Z",
    transform: "translate(-42.309 -202.635)",
    fill: "#fcf6e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M93.314,421.534v2.6a38.076,38.076,0,0,1-20.6-11.242,10.752,10.752,0,0,1,6.474-2.155h3.323A10.8,10.8,0,0,1,93.314,421.534Z",
    transform: "translate(-56.753 -346.788)",
    fill: "#145c90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M125.4,422.414a38.068,38.068,0,0,1-14.679-10.23,10.636,10.636,0,0,1,2.409-1.449H114.6a10.8,10.8,0,0,1,10.8,10.8Z",
    transform: "translate(-88.837 -346.788)",
    fill: "#145c90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M178.568,327.22v.9a2.248,2.248,0,1,1-4.5,0v-.9a2.248,2.248,0,0,1,4.5,0Z",
    transform: "translate(-142.326 -274.378)",
    fill: "#e1a595"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M69.026,259.773v3.6a9.9,9.9,0,0,1-6.819,9.406v2.4a3.073,3.073,0,1,1-6.147,0v-2.4a9.919,9.919,0,0,1-6.18-5.9,2.25,2.25,0,0,1-2.887-2.156v-.9a2.248,2.248,0,0,1,2.248-2.248v-1.8a9.892,9.892,0,1,1,19.785,0Z",
    transform: "translate(-35.033 -210.977)",
    fill: "#eac0b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M84.8,253.424a6.642,6.642,0,0,1-5.716-3.254,10.446,10.446,0,0,1-13.076,1.689c.674-3.593,7-6.843,9.18-6.979,4.733,0,9.892,4.028,9.663,8.543Z",
    transform: "translate(-51.087 -206.755)",
    fill: "#fcf6e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M308.621,410.735a10.753,10.753,0,0,1,6.609,2.258,33.561,33.561,0,0,1-20.73,11.182v-2.641a10.8,10.8,0,0,1,10.8-10.8h3.323Z",
    transform: "translate(-244.006 -346.788)",
    fill: "#69d2c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M326.769,240.782v8.4a.782.782,0,0,1-.783.783H305.953a.782.782,0,0,1-.782-.783A9.186,9.186,0,0,1,314.357,240h11.629A.783.783,0,0,1,326.769,240.782Z",
    transform: "translate(-253.016 -202.635)",
    fill: "#f4aa39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M428.127,327.22v.9a2.248,2.248,0,1,1-4.5,0v-.9a2.248,2.248,0,0,1,4.5,0Z",
    transform: "translate(-353.032 -274.378)",
    fill: "#f3d6ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M318.586,259.773v3.6a9.9,9.9,0,0,1-6.819,9.406v2.4a3.073,3.073,0,0,1-6.147,0v-2.4a9.919,9.919,0,0,1-6.18-5.9,2.25,2.25,0,0,1-2.887-2.156v-.9a2.248,2.248,0,0,1,2.248-2.248v-1.8a9.892,9.892,0,1,1,19.785,0Z",
    transform: "translate(-245.739 -210.977)",
    fill: "#f8e6cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M331.375,253.911a9.868,9.868,0,0,1-4.986-2.586,9.907,9.907,0,0,1-9.543,0,9.867,9.867,0,0,1-4.986,2.586c0-4.653,4.852-9.031,9.757-9.031S331.511,248.752,331.375,253.911Z",
    transform: "translate(-258.664 -206.755)",
    fill: "#f4aa39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestThree);
export default __webpack_public_path__ + "static/media/test-three.493ffc170c6a666850eb582692e1c415.svg";
export { ForwardRef as ReactComponent };